const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站支持1080P及以上高清播放，智能码率适配，根据网络自动调节清晰度，确保最佳观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '全球CDN加速节点覆盖，多线BGP网络架构，加载迅速播放流畅，告别卡顿等待。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '汇聚20,000+精选片源，覆盖动作、悬疑、科幻、喜剧等15+品类，每日持续更新扩充。',
  },
  {
    icon: 'ri-thumb-up-line',
    title: '人工精选',
    desc: '专业编辑团队每日甄选优质内容，结合热度数据与用户口碑，生成个性化推荐清单。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为什么选择91在线视频？四大核心优势为您保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.slice(0, 4).map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors duration-200 group"
            >
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}